import React from 'react';

import { Maybe } from '../../types/wordpress/node';
import compact from '../../utils/helpers/compact';
import { tw } from '../../utils/tailwind';
import { Stack } from '../Core';
import StyledLink from '../StyledLink';
import Text from '../Text';
import MenuItem from '.';

interface IBurgerMenuItemProps {
  currentPath: string;
  isActivePage: boolean;
  isSubmenuItem: boolean;
  menuItem: MenuItem;
  styledLinkDestination: Maybe<{
    href?: string;
    to?: string;
    isEmail?: boolean;
    shouldObfuscate?: boolean;
  }>;
}

const BurgerMenuItem: FCWithClassName<IBurgerMenuItemProps> = (props) => {
  const { isActivePage, menuItem, isSubmenuItem } = props;
  const subMenuItems = compact(menuItem?.childItems?.nodes).map((childItem) => {
    if (!childItem) return undefined;
    return (
      <MenuItem
        allowSubmenu={false}
        color="text"
        currentPath={props.currentPath}
        key={childItem.id}
        isActivePage={isActivePage}
        isSubmenuItem
        menuType="burger"
        menuItem={{
          ...childItem,
          childItems: undefined,
          locations: undefined,
          parentId: undefined,
        }}
      />
    );
  });
  const parentMenuItem = subMenuItems.length ? (
    <details>
      <summary>
        <Text
          className={tw(
            'inline-block hover:text-secondaryMain !text-5 !font-label !font-normal uppercase align-middle',
            isActivePage ? 'text-primaryMain' : ''
          )}
        >
          {props.menuItem?.label}
        </Text>
      </summary>
      {Boolean(subMenuItems.length) && (
        <Stack className="w-auto pl-4 mt-4">{subMenuItems}</Stack>
      )}
    </details>
  ) : (
    <StyledLink
      className={tw(
        'hover:!text-secondaryMain text-text text-5 font-label font-normal uppercase',
        isActivePage ? '!text-primaryMain' : ''
      )}
      {...props.styledLinkDestination}
    >
      {props.menuItem?.label}
    </StyledLink>
  );
  const submenuItem = (
    <StyledLink
      className="font-normal uppercase text-text text-5 font-label"
      {...props.styledLinkDestination}
    >
      {props.menuItem?.label}
    </StyledLink>
  );
  return isSubmenuItem ? submenuItem : parentMenuItem;
};

export default BurgerMenuItem;
